/**
 * Copyright © Veeam Software Group GmbH.
 */

import styled from 'styled-components';
import { colors, SPACING_M } from '@veeam-vspc/components';

export const WidgetViewStyled = styled.div`
    background-color: ${colors.G200};
    display: grid;
    gap: ${SPACING_M};
    grid-template-rows: auto 1fr;
    height: 100%;
    overflow: hidden;
    width: 100%;
`;
